import css from './graph.module.scss';

import _ from 'lodash';
import { memo } from 'react';

import { TRect, TStep, TX, TY } from './type';

const Grid = ({
  x,
  y,
  steps,
  graphRect,
  maxCount,
  maxWeeks,
}: {
  x: TX;
  y: TY;
  steps: TStep;
  graphRect: TRect;
  maxCount: number;
  maxWeeks: number;
}) => {
  return (
    <g data-role="grid">
      <g data-dir="horisontal">
        {_.range(steps.horisontal, maxWeeks + 1, steps.horisontal).map(num => (
          <line
            key={num}
            x1={x(num)}
            x2={x(num)}
            y1={graphRect.bottom}
            y2={graphRect.top}
            className={css.gridline}
          />
        ))}
      </g>

      <g data-dir="vertical">
        {_.range(steps.vertical, maxCount + 1, steps.vertical).map(num => (
          <line
            key={num}
            y1={y(num)}
            y2={y(num)}
            x1={graphRect.left}
            x2={graphRect.right}
            className={css.gridline}
          />
        ))}
      </g>
    </g>
  );
};

export default memo(Grid);
